export var FULL_SIZE_KEY = 'auto';